import Vue from 'vue';

import UploadPage from '../components/upload_page.vue'

import { getUploaderTranslations } from './get_meta';

var uploader = null;

function initUploader(el) {
  uploader = new Vue({
    el,
    render: h => h(UploadPage, {
      ref: "uploadpage",
      props: {
        t: getUploaderTranslations(),
        fullImageId: el.dataset.fullImageId,
        showFreeCreditInfoOnMount: (el.dataset.firstSignin === "true"),
      }
    }),
  })
}

window.addEventListener('popstate', (event) => {
  location.reload();
});

export function showUploadPage() {
  if(!uploader) {
    var t = getUploaderTranslations();
    window.history.pushState({}, t.title, t.url);

    var canonical = $("link[rel='canonical']");
    if(canonical.length == 0) {
      canonical = $("<link rel='canonical' />");
      $('head').append(canonical);
    }
    canonical.attr("href", t.url);

    var meta_description = $("meta[name='description']");
    if(meta_description.length == 0) {
      meta_description = $("<meta rel='description' />");
      $('head').append(meta_description);
    }
    meta_description.attr("content", t.meta_description);

    $("#page-content").html("<div class='upload-page-wrapper'></div>");
    initUploader($(".upload-page-wrapper")[0]);
  }
}

export function uploadFile(file) {
  showUploadPage();
  uploader.$refs.uploadpage.filePicked(file);
}

export function uploadBase64(filename, mimetype, base64) {
  showUploadPage();
  uploader.$refs.uploadpage.filePickedBase64(filename, mimetype, base64);
}

export function uploadUrl(url) {
  showUploadPage();
  uploader.$refs.uploadpage.urlPicked(url);
}

export function uploadExample(example) {
  showUploadPage();
  uploader.$refs.uploadpage.examplePicked(example);
}

$(() => {
  var uploader = $(".upload-page-wrapper");
  if(uploader.length == 0) return;
  initUploader(uploader[0]);
});
